import { NODE_TYPE_EVENT, NODE_TYPE_ORGANIZATION, NODE_TYPE_PERSON, NODE_TYPE_PLACE } from "../Node/config"

/**
 * @name ID
 * @constant
 * @string
 * @description ID used to identify this modal
 */
export const ID = 'MODIFY_NODE';

/**
 * @name EXTRA_DATA
 * @constant
 * @object
 * @description Describes different datum that can be added
 */
export const EXTRA_DATA = {
    [ NODE_TYPE_EVENT ]: {
        date: 'date',
        description: 'longText',
        image: 'image'
    },
    [ NODE_TYPE_ORGANIZATION ]: {
        description: 'longText',
        image: 'image',
        headquarters: 'text',
        industry: 'text'
    },
    [ NODE_TYPE_PERSON ]: {
        bornOn: 'date',
        description: 'longText',
        diedOn: 'date',
        ethnicity: 'text',
        height: 'distance',
        image: 'image',
        gender: 'text',
        politicalAffiliation: 'text',
        nationality: 'text',
        weight: 'weight',
    },
    [ NODE_TYPE_PLACE ]: {
        address: 'text',
        coordinates: 'coords',
        description: 'longText',
        image: 'image'
    }
};